import { UtilityIcon } from "../../../../../assets/icons";
import EmptyState from "../../../../../common/components/xepp/empty-state/EmptyState";
import DataTable, { ColumnType } from "../../../../../common/components/xepp/table/DataTable";

interface TableData {
    id: string;
    utility: string;
    country : {
        name: string;
        flagUrl: string;
    };
    totalSalesAmount: string;
    totalUnitPaid: string;
    postpaidBillsAmount: string;
    vendingTransactions: string;
    numberOfPayments: string;
}
export const BillsDashboardTable = () =>{
    const columns: Array<ColumnType<TableData>> = [
        {
          accessor: 'utility',
          header: 'Utility',
        },
        {
          accessor: 'id',
          header: 'Country',
          render: (item: TableData) => <div> item.country.name</div>
        },
        {
          accessor: 'totalSalesAmount',
          header: 'Total Sales in Amount',
        },
        {
          accessor: 'totalUnitPaid',
          header: 'Total Unit Paid (Kwh)',
        },
        {
          header: 'Postpaid Bills in Amount',
          accessor: 'postpaidBillsAmount',
        },
        {
          header: 'Vending Transactions',
          accessor: 'vendingTransactions'
        },
        {
          accessor: 'numberOfPayments',
          header: "Number of Payments",
        }
      ];
    return (
       <DataTable<TableData>
        data={[]}
        columns={columns}
        emptyComponent={<EmptyState icon={<UtilityIcon />} title='No sales data available' />}
      />
    )
}